import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=8041a1ac"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8041a1ac')) {
      api.createRecord('8041a1ac', component.options)
    } else {
      api.reload('8041a1ac', component.options)
    }
    module.hot.accept("./recommend.vue?vue&type=template&id=8041a1ac", function () {
      api.rerender('8041a1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/components/recommend.vue"
export default component.exports